module.exports = __webpack_public_path__ + "img/builds_pst:minimized@2x.0c781a3e.jpg";